var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rsf-table-cell col-12"},[_c('p',{staticClass:"open-sans-var h5 color-black center"},[_vm._v(_vm._s(_vm.measurement == 'metric' && _vm.metricValue && _vm.metricValue != '' ? _vm.metricValue : _vm.imperialValue && _vm.imperialValue != '' ? _vm.imperialValue : '-'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }